export default "__VITE_ASSET__DaITT3C___"